import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.filter('translate',
    [
        '$rootScope',
        function ($rootScope) {
            const translateFilter = function (key, data = null) {
                return $rootScope.translate(key, data);
            };

            translateFilter.$stateful = true;
            return translateFilter;
        }
    ]);
